import {
  Accordion,
  Center,
  Divider,
  Flex,
  Text,
  useMantineTheme,
} from "@mantine/core";
import BoxShop from "./Box";
import { IMyProducts } from "../../../../interfaces/MyProducts";
import { Setting3 } from "iconsax-react";
import { formatCurrency } from "../../../../utils/currency";
import { convertRecurrencyType } from "../../../../utils/convertRecurrencyType";
import { useTranslation } from "react-i18next";

interface IProps {
  product: IMyProducts;
}

const AccordionInfo = ({ product }: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <Accordion.Item value="Info">
      <Accordion.Control p="0">
        <Flex
          id="lineOneCardProduct"
          justify="start"
          align={"center"}
          gap="8px"
        >
          <Setting3 size="24" color={theme.colors.basic[5]} />
          <Text
            fz={{ base: 18 }}
            lh={{ base: "155%" }}
            c={theme.colors.basic[5]}
          >
            {t("meu_portfolio.meus_serviços.card_product.detail_title")}
          </Text>
        </Flex>
      </Accordion.Control>

      <Accordion.Panel
        styles={{
          ".content": {
            padding: "0px",
          },
        }}
      >
        {product.plans.map((plan, index) => {
          const recurrencyType = convertRecurrencyType(plan?.recurrency_type);

          return (
            <Flex
              gap="24px"
              w={"100%"}
              align={"center"}
              key={`${index}-${plan?.name}`}
            >
              <Flex gap="8px" direction={"column"} maw={"65%"} w="100%">
                <Divider
                  size={22}
                  w="100%"
                  color={theme.colors.primaryOpacity[2]}
                />
                <Flex
                  gap="24px"
                  w={"100%"}
                  align={"center"}
                  justify={"space-between"}
                >
                  <BoxShop
                    title={t(
                      "meu_portfolio.meus_serviços.card_product.name_plan"
                    )}
                    content={plan.name}
                  />
                  <BoxShop
                    title={t(
                      "meu_portfolio.meus_serviços.card_product.recurrency_type"
                    )}
                    content={t(recurrencyType)}
                  />
                  <BoxShop
                    title={t("meu_portfolio.meus_serviços.card_product.value")}
                    content={`${formatCurrency(plan.price)} a.m.`}
                  />
                  <BoxShop
                    title={t("meu_portfolio.meus_serviços.card_product.status")}
                    content={
                      plan.active
                        ? t("global.status.active")
                        : t("global.status.inactive")
                    }
                    contentUppercase
                  />
                  <BoxShop
                    title={t(
                      "meu_portfolio.meus_serviços.card_product.visibility"
                    )}
                    content={
                      plan.is_visible_on_marketplace
                        ? t("meu_portfolio.meus_serviços.card_product.visible")
                        : t(
                            "meu_portfolio.meus_serviços.card_product.invisible"
                          )
                    }
                  />
                </Flex>
              </Flex>
              <Flex gap="8px" direction={"column"} maw={"35%"} w="100%">
                <Center
                  h="22px"
                  color={theme.colors.basic[4]}
                  bg={theme.colors.primaryOpacity[1]}
                >
                  <Text
                    fz={"14px"}
                    fw={400}
                    lh={"22px"}
                    ff={"barlow"}
                    color={theme.colors.basic[4]}
                    tt={"uppercase"}
                  >
                    {t("meu_portfolio.meus_serviços.card_product.quantity")}
                  </Text>
                </Center>
                <Flex
                  gap="24px"
                  w={"100%"}
                  align={"center"}
                  justify={"space-between"}
                >
                  <BoxShop
                    title={t("meu_portfolio.meus_serviços.card_product.sell")}
                    content={plan.counts.total.toString()}
                  />
                  <BoxShop
                    title={t("meu_portfolio.meus_serviços.card_product.cancel")}
                    content={plan.counts.cancelled.toString()}
                  />
                  <BoxShop
                    title={t("meu_portfolio.meus_serviços.card_product.copy")}
                    content={plan.counts.copying.toString()}
                  />
                  <BoxShop
                    title={t(
                      "meu_portfolio.meus_serviços.card_product.pending"
                    )}
                    content={plan.counts.pending.toString()}
                  />
                  <BoxShop
                    title={t(
                      "meu_portfolio.meus_serviços.card_product.inactive"
                    )}
                    content={plan.counts.inactive.toString()}
                  />
                </Flex>
              </Flex>
            </Flex>
          );
        })}
      </Accordion.Panel>
    </Accordion.Item>
  );
};
export default AccordionInfo;
